import styled from "styled-components"

export const TweetLoad = styled.div`
	> img {
		margin: 0px 100px;
		width: 50px;
	}
`
